import { render } from "./GDQAdmin.vue?vue&type=template&id=0997dc27"
import script from "./GDQAdmin.vue?vue&type=script&lang=js"
export * from "./GDQAdmin.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__